import {
  EBankAccountType,
  EPaymentProcessor,
  schemes,
  zSchema,
} from "@zeal/common";

export const createOdoBankAccountRequestSchema = zSchema.object({
  account_number: zSchema.string(),
  account_type: zSchema.nativeEnum(EBankAccountType),
  first_name: zSchema.string(),
  is_primary: zSchema.boolean().optional(),
  last_name: zSchema.string(),
  odo_user_id: schemes.mongoOrUuid(),
  processor: zSchema.nativeEnum(EPaymentProcessor).optional(),
  routing_number: zSchema.string(),
  testMode: zSchema.boolean().optional(),
});

export type TCreateOdoBankAccountRequestSchema = zSchema.infer<
  typeof createOdoBankAccountRequestSchema
>;

export const createOdoBankAccountResponseSchema = zSchema.object({
  odo_user_id: schemes.mongoOrUuid(),
  payment_destination_id: schemes.uuid(),
});

export type TCreateOdoBankAccountResponseSchema = zSchema.infer<
  typeof createOdoBankAccountResponseSchema
>;
